/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Changelist_IdInputs */

const id_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const ms_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const da_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const de_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const en_us2_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const es_es2_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const es_mx2_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const fil_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const fr_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const it_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const hu_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azonosító`)
};

const nl_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const no_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const pl_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const pt_br2_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const pt_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const ro_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const fi_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tunnus`)
};

const sv_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const vi_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const tr_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const cs_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const bg_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const ru_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const uk_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const ar_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المعرف`)
};

const hi_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const th_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const ja_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const zh_cn2_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const zh_hant1_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const ko_components_changelist_id = /** @type {(inputs: Components_Changelist_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

/**
* | output |
* | --- |
* | "ID" |
*
* @param {Components_Changelist_IdInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelist_id = /** @type {((inputs?: Components_Changelist_IdInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelist_IdInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelist_id(inputs)
	if (locale === "ms") return ms_components_changelist_id(inputs)
	if (locale === "da") return da_components_changelist_id(inputs)
	if (locale === "de") return de_components_changelist_id(inputs)
	if (locale === "en-US") return en_us2_components_changelist_id(inputs)
	if (locale === "es-ES") return es_es2_components_changelist_id(inputs)
	if (locale === "es-MX") return es_mx2_components_changelist_id(inputs)
	if (locale === "fil") return fil_components_changelist_id(inputs)
	if (locale === "fr") return fr_components_changelist_id(inputs)
	if (locale === "it") return it_components_changelist_id(inputs)
	if (locale === "hu") return hu_components_changelist_id(inputs)
	if (locale === "nl") return nl_components_changelist_id(inputs)
	if (locale === "no") return no_components_changelist_id(inputs)
	if (locale === "pl") return pl_components_changelist_id(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelist_id(inputs)
	if (locale === "pt") return pt_components_changelist_id(inputs)
	if (locale === "ro") return ro_components_changelist_id(inputs)
	if (locale === "fi") return fi_components_changelist_id(inputs)
	if (locale === "sv") return sv_components_changelist_id(inputs)
	if (locale === "vi") return vi_components_changelist_id(inputs)
	if (locale === "tr") return tr_components_changelist_id(inputs)
	if (locale === "cs") return cs_components_changelist_id(inputs)
	if (locale === "bg") return bg_components_changelist_id(inputs)
	if (locale === "ru") return ru_components_changelist_id(inputs)
	if (locale === "uk") return uk_components_changelist_id(inputs)
	if (locale === "ar") return ar_components_changelist_id(inputs)
	if (locale === "hi") return hi_components_changelist_id(inputs)
	if (locale === "th") return th_components_changelist_id(inputs)
	if (locale === "ja") return ja_components_changelist_id(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelist_id(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelist_id(inputs)
	return ko_components_changelist_id(inputs)
});
export { components_changelist_id as "components.changelist.id" }